import { BqApiProvider } from './../../providers/bq-api/bq-api';
import { Component } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ViewController
} from 'ionic-angular';
import { ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

import { HomePage } from './../home/home';
import { XsellUpsellPage } from './../xsell-upsell/xsell-upsell';
import { AlertController } from 'ionic-angular/components/alert/alert-controller';

@IonicPage()
@Component({
  selector: 'page-general-experience',
  templateUrl: 'general-experience.html'
})
export class GeneralExperiencePage {
  public p56Selection: number;
  public p57Selection: number;
  public p58Selection: number;

  public waiting: boolean;
  public xperienceComment: string;

  constructor(
    private translate: TranslateService,
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    private bqApi: BqApiProvider,
    public alertCtrl: AlertController
  ) {
    this.p56Selection = 0;
    this.p57Selection = 0;
    this.p58Selection = 0;
    this.waiting = false;
    this.xperienceComment = '';
  }

  ionViewDidLoad() {
    this.p56Selection = this.bqApi.getStep(56) || 0;
    this.p57Selection = this.bqApi.getStep(57) || 0;
    this.p58Selection = this.bqApi.getStep(58) || 0;
    this.xperienceComment = this.bqApi.getComment(7) || '';
  }

  updateSteps() {
    if (this.p56Selection !== 0) {
      this.bqApi.setStep(56, this.p56Selection);
    }
    if (this.p57Selection !== 0) {
      this.bqApi.setStep(57, this.p57Selection);
    }
    if (this.p58Selection !== 0) {
      this.bqApi.setStep(58, this.p58Selection);
    }

    if( this.xperienceComment !== '' ){
      this.bqApi.setComment(7, this.xperienceComment );
    }

    this.bqApi.syncSteps();
  }

  nextStep() {
    this.updateSteps();
    let isValid = this.bqApi.validate();


    let prompt = this.alertCtrl.create({
      title: '¿Desea finalizar y enviar la encuesta?',
      message:
        'Por favor revise las respuestas antes de finalizar la encuesta.',
      buttons: [
        {
          text: 'Cancelar'
        },
        {
          text: 'Enviar',
          handler: data => {
            this.bqApi
              .upload()
              .then(res => {
                window.localStorage.clear();
                this.alertCtrl
                  .create({
                    title: 'Gracias!',
                    message:
                      'Se ha enviado la encuesta correctamente!',
                    buttons: [{ text: 'Finalizar', handler: data => { window.location.href = "https://bqrc.es/" }}]
                  })
                  .present();
              })
              .catch(err => {});
          }
        }
      ]
    });

    if (isValid) {
      this.waiting = true;
      prompt.present();
    } else {
      console.dir(this.bqApi.getPendingSteps())

      let errMsg = 'Por favor revise las respuestas a ';

      if( this.bqApi.getPendingSteps().length === 1 ){
        errMsg += 'la pregunta ';
      }else{
        errMsg += 'las preguntas ';
      }

      for( let step of this.bqApi.getPendingSteps() ){
        if( step <= 100 ){
          errMsg += step + ' '
        }
      }

      errMsg += ' antes de finalizar la encuesta.';

      let promptValid = this.alertCtrl.create({
        title: 'Hay preguntas sin contestar',
        message: errMsg
      });

      promptValid.present();
    }

    // this.viewCtrl.dismiss();
    // this.navCtrl.push(HomePage);
  }

  previousStep() {
    this.updateSteps();
    this.viewCtrl.dismiss();
    this.navCtrl.push(XsellUpsellPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/general-experience/general-experience.ts